import { useCallback } from 'react';
import { useTranslate } from '@agilepoint/wat-react';
import { IBinaryDataPayload, useSaveBinaryDataQuery, useGetGlobalAppImageQuery, useGetUploadedImagesQuery, useSaveTextDataQuery, useGetAppTheme } from 'modules/shared/queries';
import { CenteredSpinner, getCurrentDate, ErrorInfo } from 'common';
import { useConfigScopeSelectors } from 'modules/core/scopes';
import { UploadImages } from '../components';
import { IStyleAPIData } from 'modules/shared/types';

interface IUploadImagesContainerProps { }

export const UploadImagesContainer = (props: IUploadImagesContainerProps) => {
    const { data: appTheme, isLoading: isAppThemeLoading, isFetching: isAppthemeFeatching } = useGetAppTheme();
    const { data, isLoading, isFetching, error } = useGetGlobalAppImageQuery();
    const { data: imageData, isLoading: imageDataLoading } = useGetUploadedImagesQuery(data?.TextData ? JSON.parse(JSON.parse(data?.TextData)) : undefined);
    const { mutateAsync, isLoading: binaryDataMutationLoading } = useSaveBinaryDataQuery();
    const { mutateAsync: saveTextDataMutation, isLoading: saveDataMutationLoading } = useSaveTextDataQuery();
    const currentUserDetails = useConfigScopeSelectors().selectCurrentUserDetails();
    const translate = useTranslate();

    const onSaveBinaryData = useCallback(async (binaryDataPayload: IBinaryDataPayload[]) => {
        const ids = await Promise.all(binaryDataPayload.map((payload) => mutateAsync(payload)));
        return saveTextDataMutation({
            BinaryData: [],
            ContentType: 'json',
            ELEMENTID: '',
            SecondaryReference: `GlobalAppImages_${currentUserDetails.userName.replace(/\\/g, '_')}`,
            CreatedDate: getCurrentDate(),
            TextData: JSON.stringify(JSON.stringify(ids.map((id, index) => ({ ID: id.SaveBinaryDataResult, Name: binaryDataPayload[index].FileName })))) //API does not accept single time stringified data
        });
    }, [currentUserDetails.userName, mutateAsync, saveTextDataMutation]);

    if (isLoading || imageDataLoading || isFetching || isAppThemeLoading || isAppthemeFeatching) {
        return <CenteredSpinner spinnerType='indeterminate' size='small' text={isLoading ? translate('modules.defaultAppSettings.messages.loadingImageDetailsText') : imageDataLoading && translate('modules.defaultAppSettings.messages.loadingImageDataDetailsText')} />;

    }
    if (imageData && appTheme) {
        const { TextData } = appTheme;
        const styleData:IStyleAPIData = TextData ? JSON.parse(appTheme.TextData) : {};
        return (
            <UploadImages
                imageData={imageData}
                menuColor={styleData.menuColorCode}
                mutationLoading={binaryDataMutationLoading || saveDataMutationLoading}
                onSaveBinaryData={onSaveBinaryData} />
        );
    }

    return (
        <ErrorInfo errorObject={error} />
    );
};
